import { RgbaColor } from 'react-colorful';

const hexToRgba = (hex: string): RgbaColor | undefined => {
  if (hex.length < 7) return; // Need at least #rrggbb to avoid NaN
  return {
    r: parseInt(hex.slice(1, 3), 16),
    g: parseInt(hex.slice(3, 5), 16),
    b: parseInt(hex.slice(5, 7), 16),
    a: 1,
  };
};

export const textToRgba = (value: string | undefined): RgbaColor | undefined => {
  if (!value) return;

  if (value.startsWith('#')) {
    return hexToRgba(value);
  }

  const matches = value.match(/\d+\.?\d*/g)?.map(Number);
  if (!matches || matches.length < 3) return;

  const [r, g, b, a = 1] = matches;
  return { r, g, b, a };
};

export const rgbaToText = (rgba: RgbaColor) => {
  return `rgba(${rgba.r}, ${rgba.g}, ${rgba.b}, ${rgba.a})`;
};
